'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeInAppUsageTracker = undefined;

var _usageTrackerPublic = require('usage-tracker-public');

var _events = require('conversations-visitor-ui/events.yaml');

var _events2 = _interopRequireDefault(_events);

var _wrappedPortalIdParser = require('../../utils/wrappedPortalIdParser');

var _wrappedPortalIdParser2 = _interopRequireDefault(_wrappedPortalIdParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeInAppUsageTracker = exports.makeInAppUsageTracker = function makeInAppUsageTracker() {
  return (0, _usageTrackerPublic.createTracker)({
    events: _events2.default,
    isExternalHost: false,
    properties: {
      namespace: 'conversations-visitor-ui',
      hubId: (0, _wrappedPortalIdParser2.default)('makeInAppUsageTracker makeProperties')
    }
  });
}; // eslint-disable-line


//////////////////
// WEBPACK FOOTER
// ./js/usage-tracking/factories/makeInAppUsageTracker.js
// module id = 1231
// module chunks = 3